// File: src/pages/layout/Layout.tsx

import { Outlet } from "react-router-dom";
import styles from "./Layout.module.css";
import { isAuthEnabled } from "../../authConfig";
import { useAuth } from "../../contexts/AuthContext";
import { LoginButton } from "../../components/LoginButton/LoginButton";

const Layout = () => {
    const { loading, isAuthenticated, error } = useAuth();

    // Auth enabled: show loading spinner while MSAL initialises
    if (isAuthEnabled && loading) {
        return (
            <div className={styles.layout}>
                <div className={styles.loginGate}>
                    <div className={styles.loadingSpinner} />
                    <p style={{ marginTop: "1rem", color: "var(--text-muted)" }}>Loading...</p>
                </div>
            </div>
        );
    }

    // Auth enabled but user not signed in: show login card
    if (isAuthEnabled && !isAuthenticated) {
        return (
            <div className={styles.layout}>
                <div className={styles.loginGate}>
                    <div className={styles.loginCard}>
                        <h1 className={styles.loginTitle}>Next Sales Assistant</h1>
                        <p className={styles.loginSubtitle}>Sign in with your organization account to access this application.</p>
                        <LoginButton />
                    </div>
                </div>
            </div>
        );
    }

    // Auth succeeded at IdP level, but backend is unreachable (internal network / VPN needed)
    if (isAuthEnabled && isAuthenticated && error) {
        return (
            <div className={styles.layout}>
                <div className={styles.loginGate}>
                    <div className={styles.networkCard}>
                        <div className={styles.networkIcon} aria-hidden="true">!</div>
                        <h1 className={styles.networkTitle}>Network Access Required</h1>
                        <p className={styles.networkMessage}>{error}</p>
                        <div className={styles.networkHint}>
                            <p className={styles.networkHintTitle}>Possible causes</p>
                            <ul className={styles.networkList}>
                                <li>backend/gateway unreachable</li>
                                <li>network restriction/firewall</li>
                                <li>no internal network/VPN route</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.layout}>
            {/* Floating user button - always show when auth is enabled */}
            {isAuthEnabled && (
                <div className={styles.floatingUserButton}>
                    <LoginButton />
                </div>
            )}

            <Outlet />
        </div>
    );
};

export default Layout;
